<template>
    <nav class="sidebar-nav">
        <!-- <VuePerfectScrollbar class="scroll-area" :settings="psSettings" @ps-scroll-y="scrollHandle"> -->
            <ul class="nav">
                <li class="nav-item" >
                    <div>
                        <router-link to="/dashboard/reloader/false" class="nav-link">
                        <i class="icon-speedometer"></i> Tableau de bord
                        <!--<b-badge variant="primary">NEW</b-badge>-->
                        </router-link>
                    </div>
                </li>
                <!--<li data-v-039ccefd="" class="nav-title">
                    Centre d'appels
                </li>-->
                <li class="nav-item" v-if="isAdmin">
                    <router-link tag="setting" class="nav-item nav-dropdown" to="url" disabled>
                        <div class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fa fa-cog"></i> Paramétrage</div>
                        <ul class="nav-dropdown-items"> 
                            <li class="nav-item" v-if="can('grilletarifaire-list')">
                                <div>
                                    <router-link to="/grilletarifaires/list" class="nav-link">
                                        <i class="fa fa-fax"></i> Grilles tarifaires
                                    </router-link>
                                </div>
                            </li> 
                            <li class="nav-item" v-if="can('typepiece-list')">
                                <div>
                                    <router-link to="/typedepieces/list" class="nav-link">
                                        <i class="fa fa-linode"></i> Type de pièces
                                    </router-link>
                                </div>
                            </li>
                            <li class="nav-item" v-if="can('typeoperation-list')">
                                <div>
                                    <router-link to="/entete/list" class="nav-link">
                                        <i class="fa fa-fax"></i> Entête Type Opérations
                                    </router-link>
                                </div>
                            </li>
                            <li class="nav-item" v-if="can('typeoperation-list')">
                                <div>
                                    <router-link to="/typeoperations/list" class="nav-link">
                                        <i class="fa fa-linode"></i> Type d'opérations
                                    </router-link>
                                </div>
                            </li>
                            <li class="nav-item" v-if="can('typeoperation-list')">
                                <div>
                                    <router-link to="/commisions_speciales/list" class="nav-link">
                                        <i class="fa fa-money"></i> Commissions spéciales
                                    </router-link>
                                </div>
                            </li>
                            <li class="nav-item" v-if="can('plafond-list')">
                                <div>
                                    <router-link :to="'/plafonds/edit/'+ this.plafonds_id" class="nav-link">
                                      <i class="fa fa-money"></i> Plafond
                                    </router-link>
                                </div>
                            </li>  
                            <li class="nav-item" v-if="can('delaisretrait-list')">
                                <div>
                                    <router-link to="/delais/edit" class="nav-link">
                                      <i class="fa fa-clock-o"></i> Durée de retrait
                                    </router-link>
                                </div>
                            </li>  
                            <li class="nav-item" v-if="can('horaires-list')">
                                <div>
                                    <router-link to="/plannings/heures_ouvertures" class="nav-link">
                                        <i class="fa fa-clock-o"></i> Heures d'ouvertures
                                    </router-link>
                                </div>
                            </li> 
                            <li class="nav-item" >
                                <div>
                                    <router-link to="/transferts/paiement-masse/model" class="nav-link" v-if="can('modelpaiement-list')">
                                        <i class="fa fa-money"></i> Modèle des paiements de masse
                                    </router-link>
                                </div>
                            </li>                        
                                                    
                        </ul>
                    </router-link>
                </li>
                <li class="nav-item" v-if="can('entite-list')">
                    <div>
                        <router-link to="/entites/list" class="nav-link">
                            <i class="fa fa-user"></i> Entites
                        </router-link>
                    </div>
                </li>
                <li class="nav-item" v-if="can('agence-list')">
                    <div>
                        <router-link to="/agences/agences-own" class="nav-link">
                            <i class="fa fa-building"></i> Agences
                        </router-link>
                    </div>
                </li>
                <li class="nav-item" v-if="can('guichet-list')">
                    <div>
                        <router-link to="/guichets/guichets-own" class="nav-link">
                            <i class="fa fa-ticket"></i> Guichets
                        </router-link>
                    </div>
                </li>
               
                
                <!-- <li class="nav-item" v-if="can('tarification-list')">
                    <div>
                        <router-link to="/tarifications/list" class="nav-link">
                            <i class="fa fa-fax"></i> Tarifications
                        </router-link>
                    </div>
                <li class="nav-item" v-if="can('taxe-list')">
                    <div>
                        <router-link to="/taxes/list" class="nav-link">
                            <i class="fa fa-fax"></i> Taxes
                        </router-link>
                    </div>
                </li>-->
                
                <li class="nav-item" v-if="can('approvisionnement-list')">
                    <div>
                        <router-link to="/approvisionnements/list" class="nav-link">
                            <i class="fa fa-credit-card-alt"></i> Approvisionnements
                        </router-link>
                    </div>
                </li>
                <li class="nav-item" v-if="can('operation-list')">
                    <div>
                        <router-link to="/transferts/list" class="nav-link">
                            <i class="fa fa-money"></i> Opérations
                        </router-link>
                    </div>
                </li>
                <li class="nav-item" v-if="can('entite-list')">
                    <div>
                        <router-link to="/transferts/deblocage" class="nav-link">
                            <i class="fa fa-money"></i> Déblocage
                        </router-link>
                    </div>
                </li>
                <li class="nav-item" v-if="can('user-list')">
                    <div>
                        <router-link to="/users/list" class="nav-link">
                            <i class="fa fa-users"></i> Utilisateurs
                        </router-link>
                    </div>
                </li>
                <li class="nav-item" v-if="can('mouchard')">
                                <div>
                                    <router-link to="/mouchards" class="nav-link">
                                        <i class="fa fa-ticket"></i> Mouchards de sessions
                                    </router-link>
                                </div>
                            </li> 
                <li class="nav-item">
                    <div>
                        <router-link to="/transferts/envoi/guichet/create/null" class="nav-link" v-if="can('operation-create')">
                            <i class="fa fa-money"></i> Transfert d'argent
                        </router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <div>
                        <router-link to="/transferts/retrait/guichet/create/null" class="nav-link" v-if="can('operation-create')">
                            <i class="fa fa-money"></i> Retrait d'argent
                        </router-link>
                    </div>
                </li>
                <!--<li data-v-039ccefd="" class="nav-title" v-if="can('paiement-create')">
                    Paiement de masse
                </li>-->
                
                <li class="nav-item">
                    <div>
                        <router-link to="/transferts/paiement-masse/list/" class="nav-link" v-if="can('paiement-create')">
                            <i class="fa fa-money"></i>Consultation Paiement de masse
                        </router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <div>
                        <router-link to="/transferts/paiement-masse/retrait/" class="nav-link" v-if="can('operation-create')">
                            <i class="fa fa-money"></i>Retrait Paiement de masse
                        </router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <div>
                        <router-link to="/transferts/paiement-masse/guichet/create/null" class="nav-link" v-if="can('paiement-create')">
                            <i class="fa fa-money"></i> Paiement de masse
                        </router-link>
                    </div>
                </li>
                <!-- GESTION DU MENU AVEC L'UTILSATEUR CONNECTé-->
                <li class="nav-item">
                    <div>
                        <router-link to="/agences/agences-own" class="nav-link" v-if="can('agence-list-own')">
                            <i class="fa fa-building"></i>Agences
                        </router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <div>
                        <router-link to="/guichets/guichets-own" class="nav-link" v-if="can('guichet-list-own')">
                            <i class="fa fa-ticket"></i> Guichets
                        </router-link>
                    </div>
                </li>
                <!-- liste des opération d'un opérateur -->
                <li class="nav-item">
                    <div>
                        <router-link to="/transferts/transferts-own-entity" class="nav-link" v-if="can('operation-list-own-entite')">
                            <i class="fa fa-money"></i> Opérations
                        </router-link>
                    </div>
                </li>
                <!-- liste des operation du responsable d'entité connecté -->
                <li class="nav-item">
                    <div>
                        <router-link to="/transferts/transferts-own" class="nav-link" v-if="can('operation-list-own')">
                            <i class="fa fa-money"></i> Opérations
                        </router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <div>
                        <router-link to="/users/users-own" class="nav-link" v-if="can('user-list-own')">
                            <i class="fa fa-users"></i> Utilisateurs
                        </router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <div>
                        <router-link to="/plannings/list" class="nav-link" v-if="can('planning-list')">
                            <i class="fa fa-calendar"></i> Plannings
                        </router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <div>
                        <router-link to="/transferts/autorisation/annulation" class="nav-link" v-if="can('autorise-annulation')">
                            <i class="fa fa-calendar"></i> Autorisation annulation 
                        </router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <div>
                        <router-link to="/plafonds/autorisation" class="nav-link" v-if="can('autorise-annulation')">
                            <i class="fa fa-calendar"></i> Autorisation d'un plafond
                        </router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <div>
                        <router-link to="/transferts/annulation" class="nav-link" v-if="can('operation-annulation')">
                            <i class="fa fa-calendar"></i> Annulation d'opérations
                        </router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <div>
                        <router-link to="/approvisionnements/approvisionnements-own" class="nav-link" v-if="can('approvisionnement-list-own')">
                            <i class="fa fa-money"></i> Approvisionnements
                        </router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <router-link tag="li" class="nav-item nav-dropdown" to="url" disabled>
                        <div class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fa fa-file"></i> Etats</div>
                        <ul class="nav-dropdown-items">  
                            <li class="nav-item">
                                <div>
                                    <router-link to="/etat/tableau_bord/general" class="nav-link" v-if="can('etat-tableau-bord-general')">
                                        <i class="fa fa-file-pdf-o"></i> Tableau de bord général
                                    </router-link>
                                </div>
                            </li>                           
                            <li class="nav-item">
                                <div>
                                    <router-link to="/etat/tableau_bord/distributeur" class="nav-link" v-if="can('etat-tableau-bord-distributeur')">
                                        <i class="fa fa-file-pdf-o"></i> Tableau de bord Distributeur
                                    </router-link>
                                </div>
                            </li>                           
                            <li class="nav-item">
                                <div>
                                    <router-link to="/etat/journal/transactions" class="nav-link" v-if="can('etat-journal-decaissement')">
                                        <i class="fa fa-file-pdf-o"></i> Journal des transactions
                                    </router-link>
                                </div>
                            </li>
                            <li class="nav-item">
                                <div>
                                    <router-link to="/etat/journal/decaissements" class="nav-link" v-if="can('etat-journal-transaction')">
                                        <i class="fa fa-file-pdf-o"></i> Journal des décaissements
                                    </router-link>
                                </div>
                            </li>
                            <!-- <li class="nav-item">
                                <div>
                                    <router-link to="" class="nav-link">
                                        <i class="fa fa-file-pdf-o"></i> Transfert en attente
                                    </router-link>
                                </div>
                            </li>    
                               
                            <li class="nav-item">
                                <div>
                                    <router-link to="" class="nav-link">
                                        <i class="fa fa-file-pdf-o"></i> Situation guichets
                                    </router-link>
                                </div>
                            </li>     -->
                            <!-- <li class="nav-item">
                                <div>
                                    <router-link to="" class="nav-link">
                                        <i class="fa fa-file-pdf-o"></i> Dettes et créances distributeur
                                    </router-link>
                                </div>
                            </li>     -->
                        </ul>
                    </router-link>
                </li>
                
                <!-- <div class="nav-link nav-dropdown-toggle" @click="handleClick"><i :class="classIcon"></i> {{name}}</div>
                <ul class="nav-dropdown-items">
                <slot></slot>
                </ul> -->
                <!--<li class="nav-item">
                    <div>
                        <router-link to="/notifications/alerts" class="nav-link">
                        <i class="icon-pencil"></i> Alert
                        </router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <div>
                        <router-link to="/base/forms" class="nav-link">
                        <i class="icon-pencil"></i> Formulaire
                        </router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <div>
                        <router-link to="/notifications/badges" class="nav-link">
                        <i class="icon-pencil"></i> Badge
                        </router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <div>
                        <router-link to="/notifications/modals" class="nav-link">
                        <i class="icon-pencil"></i> Modals
                        </router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <div>
                        <router-link to="/buttons/standard-buttons" class="nav-link">
                        <i class="icon-pencil"></i> Buttons
                        </router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <div>
                        <router-link to="/buttons/dropdowns" class="nav-link">
                        <i class="icon-pencil"></i> Buttons dropdowns
                        </router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <div>
                        <router-link to="/buttons/button-groups" class="nav-link">
                        <i class="icon-pencil"></i> Buttons groups
                        </router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <div>
                        <router-link to="/buttons/brand-buttons" class="nav-link">
                        <i class="icon-pencil"></i> Buttons Brand
                        </router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <div>
                        <router-link to="/widgets" class="nav-link">
                        <i class="icon-pencil"></i> Widget
                        </router-link>
                    </div>
                </li>-->
            </ul>
        <!-- </VuePerfectScrollbar> -->
    </nav>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
    name:'sidebar',
    data () {
        return {
            isAdmin:false,
            plafonds_id:'',
            psSettings: {
                maxScrollbarLength: 200,
                minScrollbarLength: 40,
                suppressScrollX: true,
                wheelPropagation: false,
                interceptRailY: styles => ({ ...styles, height: 0 })
            }
        }
    },
    methods:{
        scrollHandle (evt) {
        // console.log(evt)
        },
        can(perm){
            return store.getters['auth/can'](perm)
        },
        handleClick (e) {
            e.preventDefault()
            e.target.parentElement.classList.toggle('open')
        },
        async getPlafonds() {
            let response = await this.$store.dispatch('plafonds/get_all_plafonds')
            this.plafonds_id = response.data.id

      },
      async get_user(){
        this.res = await store.getters['auth/get_user']
        console.log(this.res.role)
        if(this.res.role.toUpperCase() =="SUPER ADMIN" || this.res.role.toUpperCase().search("RESPONSABLE") != -1){
            this.isAdmin=true
            }
            return this.res
        }
    },
    mounted(){
        this.getPlafonds()
        this.get_user()
    }
}
</script>
<style scoped lang="css">
  .scroll-area {
    position: absolute;
    height: 100%;
    margin: auto;
  }
</style>